<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-compare-metrics-result">
    <div ref="comparisonTable" class="div-talbe">
      <table class="comparison-talbe">
        <tr class="tr-header">
          <th class="with-boder"></th>
          <th class="with-boder">Comparison Period A</th>
          <th class="with-boder">Comparison Period B</th>
          <th colspan="2">Change</th>
        </tr>
        <tr class="tr-header-bottom">
          <td class="col-1"></td>
          <td class="col-2">{{parent.dateRangeDisplayA}}</td>
          <td class="col-3">{{parent.dateRangeDisplayB}}</td>
          <td class="col-4">Value</td>
          <td class="col-5">%</td>
        </tr>
        <tr class="tr-row chat-valume-row selected" @click="handleChatVolume">
          <td class="col-1">Volume</td>
          <td class="col-2">{{dataA.tableData.chatVolumeDMValue ? formatterNumber(dataA.tableData.chatVolumeDMValue) : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.chatVolumeDMValue ? formatterNumber(dataB.tableData.chatVolumeDMValue) : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.chatVolumeDMValue">
              <span :class="(chatVolumeTotalDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(chatVolumeTotalDiff))}}</span>
              <span v-if="chatVolumeTotalDiff != 0" :class="(chatVolumeTotalDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.chatVolumeDMValue">
              <span :class="(chatVolumePercentageDiff < 0?'percent down':'percent up')">{{Math.abs(chatVolumePercentageDiff)}}%</span>
              <span v-if="chatVolumePercentageDiff != 0" :class="(chatVolumePercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row chat-valume-row" @click="handleBas">
          <td class="col-1">Bot Automation Score</td>
          <td class="col-2">{{dataA.tableData.avgBasPercentage >= 0 ? `${dataA.tableData.avgBasPercentage}%` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.avgBasPercentage >= 0 ? `${dataB.tableData.avgBasPercentage}%` : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.avgBasPercentage&&this.dataB.tableData.avgBasPercentage>-1 
              && this.dataA.tableData.avgBasPercentage&&this.dataA.tableData.avgBasPercentage>-1">
              <span :class="(basAvgDiff < 0?'percent down':'percent up')">{{Math.abs(basAvgDiff)}}%</span>
              <span v-if="basAvgDiff != 0" :class="(basAvgDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.avgBasPercentage && this.dataB.tableData.avgBasPercentage > -1 
              && this.dataA.tableData.avgBasPercentage && this.dataA.tableData.avgBasPercentage > -1">
              <span :class="(basPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(basPercentageDiff)}}%</span>
              <span v-if="basPercentageDiff != 0" :class="(basPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row chat-valume-row" @click="handleBes">
          <td class="col-1">Bot Experience Score</td>
          <td class="col-2">{{dataA.tableData.avgBesPercentage >= 0 ? `${dataA.tableData.avgBesPercentage}` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.avgBesPercentage >= 0 ? `${dataB.tableData.avgBesPercentage}` : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.avgBesPercentage&&this.dataB.tableData.avgBesPercentage>-1 
              && this.dataA.tableData.avgBesPercentage&&this.dataA.tableData.avgBesPercentage>-1">
              <span :class="(besAvgDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(besAvgDiff))}}</span>
              <span v-if="besAvgDiff != 0" :class="(besAvgDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.avgBesPercentage && this.dataB.tableData.avgBesPercentage > -1
              && this.dataA.tableData.avgBesPercentage && this.dataA.tableData.avgBesPercentage > -1">
              <span :class="(besPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(besPercentageDiff)}}%</span>
              <span v-if="besPercentageDiff != 0" :class="(besPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          </tr>
          <tr class="tr-row chat-valume-row" @click="handleAes">
          <td class="col-1">Agent Experience Score</td>
          <td class="col-2">{{dataA.tableData.avgAes >= 0 ? `${dataA.tableData.avgAes}` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.avgAes >= 0 ? `${dataB.tableData.avgAes}` : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.avgAes&&this.dataB.tableData.avgAes>-1
              && this.dataA.tableData.avgAes&&this.dataA.tableData.avgAes>-1">
              <span :class="(avgAesDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(avgAesDiff))}}</span>
              <span v-if="avgAesDiff != 0" :class="(avgAesDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.avgAes && this.dataB.tableData.avgAes > -1
              && this.dataA.tableData.avgAes && this.dataA.tableData.avgAes > -1">
              <span :class="(avgAesPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(avgAesPercentageDiff)}}%</span>
              <span v-if="avgAesPercentageDiff != 0" :class="(avgAesPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr v-if="showSection('totalContainmentPercent')" class="tr-row chat-valume-row" @click="handleContainment">
          <td class="col-1">Containment Rate</td>
          <td class="col-2">{{dataA.tableData.containmentPercentage ? `${dataA.tableData.containmentPercentage}%` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.containmentPercentage ? `${dataB.tableData.containmentPercentage}%` : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.containmentPercentage">
              <span :class="(containmentDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(containmentDiff))}}%</span>
              <span :class="(containmentDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.containmentPercentage">
              <span :class="(containmentPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(containmentPercentageDiff)}}%</span>
              <span v-if="containmentPercentageDiff != 0" :class="(containmentPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr v-if="showSection('totalContainment')" class="tr-row chat-valume-row" @click="handleContainedConversations">
          <td class="col-1">Contained Conversations Volume</td>
          <td class="col-2">{{dataA.tableData.totalContainment ? `${formatterNumber(dataA.tableData.totalContainment)}` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.totalContainment ? `${formatterNumber(dataB.tableData.totalContainment)}` : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.totalContainment">
              <span :class="(totalContainmentDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(totalContainmentDiff))}}</span>
              <span :class="(totalContainmentDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.totalContainment">
              <span :class="(totalContainmentPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(totalContainmentPercentageDiff)}}%</span>
              <span v-if="totalContainmentPercentageDiff != 0" :class="(totalContainmentPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row handling-time-row" @click="handleHandingTime">
          <td class="col-1">Total Handle Time</td>
          <td class="col-2">{{handlingTimesA}}</td>
          <td class="col-3">{{handlingTimesB}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime==0">
              <span :class="((this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime) < 0?'percent down':'percent up')">{{handleTimesTotalDiff}}</span>
              <span v-if="this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime != 0" :class="((this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime) < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime==0">
              <span :class="(handleTimesPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(handleTimesPercentageDiff)}}%</span>
              <span v-if="handleTimesPercentageDiff != 0" :class="(handleTimesPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr v-if="!isHideResponse" class="tr-row handling-time-row" @click="handleResponseTime">
          <td class="col-1">Agent Response Time</td>
          <td class="col-2">{{responseTimesA}}</td>
          <td class="col-3">{{responseTimesB}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.responseTime || this.dataB.tableData.responseTime==0">
              <span :class="((this.dataB.tableData.responseTime - this.dataA.tableData.responseTime) < 0?'percent down':'percent up')">{{responseTimesTotalDiff}}</span>
              <span v-if="this.dataB.tableData.responseTime - this.dataA.tableData.responseTime != 0" :class="((this.dataB.tableData.responseTime - this.dataA.tableData.responseTime) < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.responseTime || this.dataB.tableData.responseTime==0">
              <span :class="(responseTimesPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(responseTimesPercentageDiff)}}%</span>
              <span v-if="responseTimesPercentageDiff != 0" :class="(responseTimesPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <!-- <tr class="tr-row resolution-row" @click="handleResolution">
          <td class="col-1">Resolution</td>
          <td class="col-2">{{dataA.tableData.resolution}}%</td>
          <td class="col-3">{{dataB.tableData.resolution ? `${dataB.tableData.resolution}%` : 'N/A'}}</td>
          <td class="col-4">
            -
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.resolution">
              <span :class="(resolutionPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(resolutionPercentageDiff)}}%</span>
              <span :class="(resolutionPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr> -->
        <!-- hide for OC-1171
        <tr v-if="showSection('avgTransfers')" class="tr-row chat-valume-row" @click="handleTransfers">
          <td class="col-1">Average Handoffs</td>
          <td class="col-2">{{dataA.tableData.transfers || dataA.tableData.transfers==0 ? formatterNumber(dataA.tableData.transfers) : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.transfers || dataB.tableData.transfers==0 ? formatterNumber(dataB.tableData.transfers) : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.transfers || dataB.tableData.transfers==0">
              <span :class="(chatTransfersTotalDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(chatTransfersTotalDiff))}}</span>
              <span v-if="chatTransfersTotalDiff != 0" :class="(chatTransfersTotalDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.transfers || dataB.tableData.transfers==0">
              <span :class="(chatTransfersPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(chatTransfersPercentageDiff)}}%</span>
              <span v-if="chatTransfersPercentageDiff != 0" :class="(chatTransfersPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        -->
        <tr class="tr-row sentiment-row" @click="handleSentiment">
          <td class="col-1">Sentiment</td>
          <td class="col-2"></td>
          <td class="col-3"></td>
          <td class="col-4"></td>
          <td class="col-5"></td>
        </tr>
        <tr class="sentiment-positive-row">
          <td class="col-1">Positive</td>
          <td class="col-2">{{dataA.tableData.settlementPositivePercentage ? `${dataA.tableData.settlementPositivePercentage}%` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.settlementPositivePercentage ? `${dataB.tableData.settlementPositivePercentage}%` : 'N/A'}}</td>
          <td class="col-4">
            <!-- <span :class="(settlementPositiveTotalDiff < 0?'percent down':'percent up')">{{Math.abs(settlementPositiveTotalDiff)}}%</span>
            <span :class="(settlementPositiveTotalDiff < 0?'bottom-right down':'top-right up')"></span> -->
            <div v-if="this.dataB.tableData.settlementPositivePercentage">
              <span :class="(settlementPositiveDiff < 0?'percent down':'percent up')">{{Math.abs(settlementPositiveDiff)}}%</span>
              <span v-if="settlementPositiveDiff != 0" :class="(settlementPositiveDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.settlementPositivePercentage">
              <span :class="(settlementPositivePercentageDiff < 0?'percent down':'percent up')">{{Math.abs(settlementPositivePercentageDiff)}}%</span>
              <span v-if="settlementPositivePercentageDiff != 0" :class="(settlementPositivePercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <!-- <tr>
          <td class="col-1">Neutral</td>
          <td class="col-2">{{tableData.neutralA}}</td>
          <td class="col-3">{{tableData.neutralB}}</td>
          <td class="col-4"><span class="percent up">{{tableData.neutralTotal}}</span> <span class="top-right up"></span></td>
          <td class="col-5"><span class="percent up">{{tableData.neutralPercentage}}</span> <span class="top-right up"></span></td>
        </tr> -->
        <tr class="sentiment-negative-row">
          <td class="col-1">Negative</td>
          <td class="col-2">{{dataA.tableData.settlementNegativePercentage ? `${dataA.tableData.settlementNegativePercentage}%` : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.settlementNegativePercentage ? `${dataB.tableData.settlementNegativePercentage}%` : 'N/A'}}</td>
          <td class="col-4">
            <!-- <span :class="(settlementNegativeTotalDiff < 0?'percent down':'percent up')">{{Math.abs(settlementNegativeTotalDiff)}}%</span>
            <span :class="(settlementNegativeTotalDiff < 0?'bottom-right down':'top-right up')"></span> -->
            <div v-if="this.dataB.tableData.settlementNegativePercentage">
              <span :class="(settlementNegativeDiff < 0?'percent down':'percent up')">{{Math.abs(settlementNegativeDiff)}}%</span>
              <span v-if="settlementNegativeDiff != 0" :class="(settlementNegativeDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.settlementNegativePercentage">
              <span :class="(settlementNegativePercentageDiff < 0?'percent down':'percent up')">{{Math.abs(settlementNegativePercentageDiff)}}%</span>
              <span v-if="settlementNegativePercentageDiff != 0" :class="(settlementNegativePercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="div-topic-picker">
      <div class="topic-picker-header">Topics Compared</div>
      <div class="div-selected-topic-content" ref="topicContent">
        <div :title="topic.label" class="div-item" v-for="topic in selectedTopicList" :key="topic.label">
          {{topic.label}}
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import WyUtils from '../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-analytics-compare-metrics-result',  
  props: ['parent', 'dataA', 'dataB'],
  data() {
    return {
      tableData: {},
      table: null,
      topicContent: null
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'isHideResponse']),

    selectedTopicList() {
      if(this.parent.selecteTopicList) {
        return this.parent.selecteTopicList;
      }
      return [];
    },

    handlingTimesA() {
      if(this.dataA.tableData.handlingTime || this.dataA.tableData.handlingTime == 0) {
        return (this.dataA.tableData.handlingTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataA.tableData.handlingTime*60);
      }
      else {
        return 'N/A';
      }
    },
    handlingTimesB() {
      if(this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime == 0) {
        return (this.dataB.tableData.handlingTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataB.tableData.handlingTime*60);
      }
      else {
        return 'N/A';
      }
    },
    responseTimesA() {
      if(this.dataA.tableData.responseTime || this.dataA.tableData.responseTime == 0) {
        return (this.dataA.tableData.responseTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataA.tableData.responseTime*60);
      }
      else {
        return 'N/A';
      }
    },
    responseTimesB() {
      if(this.dataB.tableData.responseTime || this.dataB.tableData.responseTime == 0) {
        return (this.dataB.tableData.responseTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataB.tableData.responseTime*60);
      }
      else {
        return 'N/A';
      }
    },
    
    handleTimesTotalDiff() {
      return WyUtils.toNiceTimeFormat(Math.abs(this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime)*60);
    },
    handleTimesPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.handlingTime, this.dataB.tableData.handlingTime);
    },

    responseTimesTotalDiff() {
      return WyUtils.toNiceTimeFormat(Math.abs(this.dataB.tableData.responseTime - this.dataA.tableData.responseTime)*60);
    },
    responseTimesPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.responseTime, this.dataB.tableData.responseTime);
    },

    chatVolumeTotalDiff() {
      return this.dataB.tableData.chatVolumeDMValue - this.dataA.tableData.chatVolumeDMValue;
    },
    chatTransfersTotalDiff() {
      return this.dataB.tableData.transfers - this.dataA.tableData.transfers;
    },

    chatTransfersPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.transfers, this.dataB.tableData.transfers);
    },
    
    chatVolumePercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.chatVolumeDMValue, this.dataB.tableData.chatVolumeDMValue);
    },

    resolutionTotalDiff() {
      return (this.dataB.tableData.resolution - this.dataA.tableData.resolution).toFixed(2);
    },
    resolutionPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.resolution, this.dataB.tableData.resolution);
    },

    containmentDiff() {
      return (this.dataB.tableData.containmentPercentage >= 0 && this.dataA.tableData.containmentPercentage >= 0) ? (this.dataB.tableData.containmentPercentage - this.dataA.tableData.containmentPercentage) : null;
    },

    containmentPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.containmentPercentage, this.dataB.tableData.containmentPercentage);
    },

    totalContainmentDiff() {
      return (this.dataB.tableData.totalContainment >= 0 && this.dataA.tableData.totalContainment >= 0) ? (this.dataB.tableData.totalContainment - this.dataA.tableData.totalContainment) : null;
    },

    totalContainmentPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.totalContainment, this.dataB.tableData.totalContainment);
    },

    settlementPositiveTotalDiff() {
      return (this.dataB.tableData.settlementPositivePercentage - this.dataA.tableData.settlementPositivePercentage).toFixed(2); //(this.dataB.tableData.settlementPositiveTotal - this.dataA.tableData.settlementPositiveTotal);
    },

    settlementPositiveDiff() {
      return (this.dataB.tableData.settlementPositivePercentage >= 0 && this.dataA.tableData.settlementPositivePercentage >= 0) ? (this.dataB.tableData.settlementPositivePercentage - this.dataA.tableData.settlementPositivePercentage).toFixed(2) : null;
    },

    settlementPositivePercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.settlementPositivePercentage, this.dataB.tableData.settlementPositivePercentage);
    },

    settlementNegativeTotalDiff() {
      return (this.dataB.tableData.settlementNegativePercentage - this.dataA.tableData.settlementNegativePercentage).toFixed(2); //(this.dataB.tableData.settlementNegativeTotal - this.dataA.tableData.settlementNegativeTotal);
    },

    settlementNegativeDiff() {
      return (this.dataB.tableData.settlementNegativePercentage >= 0 && this.dataA.tableData.settlementNegativePercentage >= 0) ? (this.dataB.tableData.settlementNegativePercentage - this.dataA.tableData.settlementNegativePercentage).toFixed(2) : null;
    },

    settlementNegativePercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.settlementNegativePercentage, this.dataB.tableData.settlementNegativePercentage);
    },

    basAvgDiff() {
      return (this.dataB.tableData.avgBasPercentage >= 0 && this.dataA.tableData.avgBasPercentage >= 0) ? (this.dataB.tableData.avgBasPercentage  -  this.dataA.tableData.avgBasPercentage) : null;
    },
    besAvgDiff() {
      return (this.dataB.tableData.avgBesPercentage >= 0 && this.dataA.tableData.avgBesPercentage >= 0) ? (this.dataB.tableData.avgBesPercentage  -  this.dataA.tableData.avgBesPercentage) : null;
    },
    avgAesDiff() {
      return (this.dataB.tableData.avgAes >= 0 && this.dataA.tableData.avgAes >= 0) ? (this.dataB.tableData.avgAes  -  this.dataA.tableData.avgAes) : null;
    },

    basPercentageDiff() {
      return WyUtils.calculatePercentage((this.dataA.tableData.avgBasPercentage == -1 ? 0 : this.dataA.tableData.avgBasPercentage), this.dataB.tableData.avgBasPercentage);
    },
    besPercentageDiff() {
      return WyUtils.calculatePercentage((this.dataA.tableData.avgBesPercentage == -1 ? 0 : this.dataA.tableData.avgBesPercentage), this.dataB.tableData.avgBesPercentage);
    },
    avgAesPercentageDiff() {
      return WyUtils.calculatePercentage((this.dataA.tableData.avgAes == -1 ? 0: this.dataA.tableData.avgAes), this.dataB.tableData.avgAes);
    },
    
  },

  methods: {
    showSection(sectionName) {
      let isShow = true;
      this.dataModel.columns.forEach(column => {
        if(column.name == sectionName) {
          if(column.hide){
            isShow = false;
          }
        }
      });
      if(this.topicContent) {
        this.topicContent.style.height = (this.table.offsetHeight - 73) + "px"
      }
      return isShow;
    },

    handleSelectEvent(e) {
      switch(e.target.nodeName) {
        case 'DIV':
          e.target.parentNode.parentNode.classList.add("selected");
          break;
        case 'SPAN':
          e.target.parentNode.parentNode.parentNode.classList.add("selected");
          break;
        default:
          e.target.parentNode.classList.add("selected");
      }
    },
    
    handleHandingTime(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleHandingTime();
    },

    handleResponseTime(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleResponseTime();
    },

    handleChatVolume(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleChatVolume();
    },

    handleTransfers(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleTransfers();
    },

    handleContainment(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleContainment();
    },

    handleContainedConversations(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleContainedConversations();
    },

    handleBas(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleBas();
    },

    handleBes(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleBes();
    },

    handleAes(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleAes();
    },

    handleResolution(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleResolution();
    },

    handleSentiment(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleSentiment();
    },

    formatterNumber(value) {
      return WyUtils.formatterNumber(value);
    },
    removeClassName(e, className) {
      document.querySelectorAll(".tr-row").forEach(el => {
        if((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1){
          el.classList.remove(className);
        }
      })
    }
  },
  mounted() {
    this.table = this.$refs.comparisonTable;
    this.topicContent = this.$refs.topicContent;
    setTimeout(()=>{
      this.parent.$refs.compareMetricsChart.handleChatVolume();
    },200)
  }
});
</script>

<style lang="scss">
.wy-analytics-compare-metrics-result {
  min-height: 200px;
  padding: 0px 0px 20px 0px;
  margin-bottom: 0px;

  .div-talbe {
    width: 79%;
    display: inline-block;
    margin: 0px 0 0px 0;
    box-shadow: 0px 1px 5px #0000001A;
    border-radius: 10px;
    background-color: #fff;
    opacity: 1;
    padding: 10px 0px 15px 0px;
    // height: 260px;
    height: fit-content;

    .comparison-talbe {
      width: 100%;
      display: inline-table;
      border-spacing: 0px;
      th {
        width: 25%;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        color: #002852;
      }
      tr:hover {
        background: #f5f7fa;
        cursor: default;
      } 
      th.with-boder {
        border-right: 1px solid #D5D5D5;
      }
      .tr-header:hover, .tr-header-bottom:hover, .sentiment-positive-row:hover, .sentiment-negative-row:hover{
        background: unset;
      }
      .handling-time-row,.chat-valume-row,.resolution-row,.sentiment-row {
        td {
          cursor: pointer;
        }
      }
      .selected {
        background: #E2ECF7;
        font-weight: bold;
      }
      .tr-header-bottom td{
        border-bottom: 1px solid #D5D5D5;
      }

      .col-1, .col-2, .col-3 {
        width: 25%;
        font-size: 11px;
        text-align: center;
        line-height: 24px;
        border-right: 1px solid #D5D5D5;
        padding-right: 0px;
        color: #002852;
      }
      .col-1 {
        font-size: 12px !important;
        padding-left: 70px;
        text-align: left;
      }
      .tr-header-bottom{
        .col-2, .col-3, .col-4, .col-5 {
          font-weight: 500;
          text-align: center;
          padding-right: 0px;
          font-size: 11px;
        }
      }
      .col-4 {
        width: 14%;
        border-right: 1px solid #D5D5D5;
      }
      .col-5 {
        width: 12%;
      }
      .col-4, .col-5 {
        font-size: 11px;
        text-align: center;
        line-height: 22px;
      }
      .sentiment-positive-row {
        .col-1 {
          font-size: 9px;
          font-style: italic;
          padding-left: 80px;
        }
      }
      .sentiment-negative-row {
        .col-1 {
          font-size: 9px;
          font-style: italic;
          padding-left: 80px;
        }
      }
    }

    .percent.up {
      margin-left: 0px;
      color: #4448A2;
    }
    .percent.down {
      margin-left: 0px;
      color: #3E6891;
    }
    .bottom-right.down {
      background-image: url("../../assets/icons/icon_arrow_down.svg");
      color: #3E6891;
      background-size: 100%;
      background-position-x: 1px;
      background-position-y: 3px;
      background-repeat: no-repeat;
      height: 13px;
      width: 13px;
      display: inline-block;
    }
    .top-right.up {
      background-image: url("../../assets/icons/icon_arrow_up.svg");
      color: #4448A2;
      background-size: 100%;
      background-position-x: 1px;
      background-position-y: 3px;
      background-repeat: no-repeat;
      height: 13px;
      width: 13px;
      display: inline-block;
    }
  }
  .div-topic-picker {
    float: right;
    width: 20%;    
    box-shadow: 0px 1px 5px #0000001A;
    border-radius: 10px;
    background-color: #fff;
    opacity: 1;
    padding-bottom: 10px; 

    .topic-picker-header {
      font-size: 12px;
      line-height: 12px;
      font-weight: 600;
      text-align: center;
      padding-top: 28px;
      padding-bottom: 10px;
      color: #002852;
    }
    .div-selected-topic-content {
      height: 212px;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #FFF;
      padding: 6px 0px 7px 0px;
      

      .div-item {
        color: #002852;
        font-weight: normal;
        font-size: 11px;
        line-height: 22px;
        padding-left: 15px;
        width: 88%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      // .div-item:hover {
      //   //background: #E2ECF7;
      //   cursor: default;
      // }
      // .div-item:hover .el-icon-error {
      //   display: block; 
      // }
    }
  }
}
</style>